import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';
const {Text} = Typography;
const Content = Layout;

const EAUNP = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>The purpose of this protocol is to determine if the binding of the aptamers, that had the thiol modification, with the gold nanoparticles was properly made and be ready to use in the Lateral Flow Assay. This is made by only performing an agarose electrophoresis gel.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Content style={{width: '15vh', marginLeft: '54vh', background: 'transparent'}}><p><i>Go to pdf</i></p></Content>
              <a style={{width: 'fit-content', marginLeft: '58vh'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/wet-lab/pdfs/4-gel-electrophoresis-with-aunps.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
            </Content>
          </Layout>
        </Content>
        <Divider/>
      </Layout>
    </Layout>
  );
};

export default EAUNP;
